import React, { Fragment } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import { positiveNumberPattern } from "../../../constants/constants";
import {
  getFormattedDate,
  getFullName,
  getGenderName,
  getMaritalName
} from "../../../util/helpers";
import {
  getDeclarationPlace,
  getFatherOrMotherOrSpouseName
} from "../../../util/onBoardingDataFilters";
import useValidation from "../../../util/useValidation";

const EPFForm11 = ({
  genders,
  maritalStatusList,
  personalDetails,
  updatePersonalDetails
}) => {
  const {
    ePFIsFatherOrMotherOrSpouse,
    familyMembers,
    isInternationalWorker,
    nationality
  } = personalDetails;

  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    if (
      name === "isEarlierEPF1952Scheme" ||
      name === "isEarlierEPF1995Scheme" ||
      name === "isInternationalWorker" ||
      name === "ePFIsFatherOrMotherOrSpouse"
    ) {
      value = parseInt(value);
      updatePersonalDetails(name, value);
    } else {
      updatePersonalDetails(name, value);
    }
    if (
      (name === "isEarlierEPF1952Scheme" &&
        personalDetails.isEarlierEPF1995Scheme === 0) ||
      (name === "isEarlierEPF1995Scheme" &&
        personalDetails.isEarlierEPF1952Scheme === 0 &&
        value === 0)
    ) {
      updatePersonalDetails("previousEmpExitDate", "");
    }
  };

  const getInternationalWorker = () => {
    if (isInternationalWorker === 0 || isInternationalWorker) {
      return isInternationalWorker;
    } else {
      return nationality;
    }
  };
  return (
    <Fragment>
      <Card>
        <Card.Header className="text-center">
          New Form No – 11 –Declaration Form
          <p className="mb-0">
            (To be retained by employer for future reference)
          </p>
        </Card.Header>
        <Card.Body>
          <div className="justify-content-center align-items-center text-center d-flex flex-column font-weight-bold mb-2">
            <p className="mb-0">EMPLOYEES’ PROVIDENT FUND ORGANISATION</p>
            <p className="mb-0">
              EMPLOYEES’PROVIDENT FUNDS SCHEME,1952 (PARAGRAPH-34&57) &
              EMPLOYEES’PENSION SCHEME,1995 (PARAGRAPH-24)
            </p>
            <p className="mb-0">
              (DECLARATION BY A PERSON TAKING UP EMPLOYMENT IN AN ESTABLISHMENT
              ON WHICH EPF SCHEME, 1952 AND/OR EPS, 1995 IS APPLICABLE)
            </p>
          </div>

          <Form.Group as={Row} controlId="NameOfTheMember">
            <Col className="mt-2" sm={1}>
              1
            </Col>
            <Form.Label column sm={4}>
              Name of the member*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Name of the member"
                type="text"
                disabled={true}
                name="nameOfTheMember"
                value={getFullName(personalDetails)}
              />
            </Col>
            <Col sm={4} />
          </Form.Group>

          <Form.Group className="row-with-mb-zero-label-pt-zero" as={Row}>
            <Col sm={1}>2</Col>
            <Form.Label column sm={4}>
              Father’s / Mother's / Spouse’s Name*
            </Form.Label>
            <Col sm={3}>
              <div>
                <Form.Check
                  id="father-relation"
                  inline
                  label="Father"
                  name="ePFIsFatherOrMotherOrSpouse"
                  onChange={handleOnChangePersonalDetails}
                  required
                  checked={ePFIsFatherOrMotherOrSpouse === 1}
                  type="radio"
                  value={1}
                />
                <Form.Check
                  id="mother-relation"
                  inline
                  label="Mother"
                  name="ePFIsFatherOrMotherOrSpouse"
                  checked={ePFIsFatherOrMotherOrSpouse === 2}
                  onChange={handleOnChangePersonalDetails}
                  required
                  type="radio"
                  value={2}
                />
                <Form.Check
                  id="spouse-relation"
                  inline
                  label="Spouse"
                  name="ePFIsFatherOrMotherOrSpouse"
                  checked={ePFIsFatherOrMotherOrSpouse === 3}
                  onChange={handleOnChangePersonalDetails}
                  disabled={!getFatherOrMotherOrSpouseName(3, familyMembers)}
                  required
                  type="radio"
                  value={3}
                />
              </div>
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="fatherOrSpouseName">
            <Col sm={5} />
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                disabled
                placeholder="Father’s / Mother's/ Spouse’s Name"
                type="text"
                value={getFatherOrMotherOrSpouseName(
                  ePFIsFatherOrMotherOrSpouse,
                  familyMembers
                )}
                onChange={handleOnChangePersonalDetails}
                name="epfForm11FatherOrSpouseName"
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="dateOfBirth">
            <Col className="mt-2" sm={1}>
              3
            </Col>
            <Form.Label column sm={4}>
              Date of Birth*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Date of Birth"
                type="date"
                name="dob"
                value={getFormattedDate(
                  personalDetails.birthDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
                disabled={true}
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="gender">
            <Col className="mt-2" sm={1}>
              4
            </Col>
            <Form.Label column sm={4}>
              Gender*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                name="gender"
                value={getGenderName(personalDetails.gender, genders)}
                disabled
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="maritalStatus">
            <Col className="mt-2" sm={1}>
              5
            </Col>
            <Form.Label column sm={4}>
              Marital Status*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="maritalStatus"
                placeholder="Marital Status"
                value={getMaritalName(
                  personalDetails.maritalStatus,
                  maritalStatusList
                )}
                disabled
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="emailID">
            <Col className="mt-2" sm={1}>
              6
            </Col>
            <Form.Label column sm={4}>
              (a) Email ID*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Email ID"
                type="text"
                name="emailId"
                value={personalDetails.emailId}
                disabled={true}
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="mobileNo">
            <Col sm={1} />
            <Form.Label column sm={4}>
              (b) Mobile No*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Mobile No"
                type="text"
                name="mobileNo"
                value={personalDetails.contactNumber}
                disabled={true}
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="earlierMemberOfProvidentFund">
            <Col className="mt-2" sm={1}>
              7
            </Col>
            <Form.Label column sm={4}>
              WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PROVIDENT FUND
              SCHEME,1952?
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PROVIDENT FUND SCHEME,1952?"
                as="select"
                name="isEarlierEPF1952Scheme"
                value={personalDetails.isEarlierEPF1952Scheme}
                onChange={handleOnChangePersonalDetails}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Control>
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="earlierMemberOfProvident1995">
            <Col className="mt-2" sm={1}>
              8
            </Col>
            <Form.Label column sm={4}>
              WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PENSION SCHEME, 1995?*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PENSION SCHEME, 1995?"
                as="select"
                name="isEarlierEPF1995Scheme"
                value={personalDetails.isEarlierEPF1995Scheme}
                onChange={handleOnChangePersonalDetails}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Control>
            </Col>
            <Col sm={4} />
          </Form.Group>
          <div className="row mb-3">
            <Col sm={1}>9</Col>
            <Col sm={6}>
              PREVIOUS EMPLOYMENT DETAILS; (if Yes to 7 AND/OR 8 above)
            </Col>
          </div>
          <Form.Group as={Row} controlId="uAN">
            <Col sm={1} />
            <Form.Label column sm={4}>
              a) UNIVERSAL ACCOUNT NUMBER*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="UNIVERSAL ACCOUNT NUMBER"
                type="text"
                maxLength={12}
                name="pfUanNo"
                pattern={positiveNumberPattern}
                value={personalDetails.pfUanNo}
                onChange={handleOnChangePersonalDetails}
                disabled={
                  personalDetails.isEarlierEPF1952Scheme === 0 &&
                  personalDetails.isEarlierEPF1995Scheme === 0
                }
                onBlur={handleOnBlurInput}
                isInvalid={errors.pfUanNo}
              />
              {errors.pfUanNo && (
                <Form.Control.Feedback type="invalid">
                  {errors.pfUanNo.type === "required" &&
                    "UNIVERSAL ACCOUNT NUMBER is required"}
                  {errors.pfUanNo.type === "pattern" &&
                    "UNIVERSAL ACCOUNT NUMBER should be a numeric value"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="pFAccountNumber">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              b) PREVIOUS PF Account Number*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="PREVIOUS PF Account Number"
                type="text"
                name="previousPFNumber"
                value={personalDetails.previousPFNumber}
                onChange={handleOnChangePersonalDetails}
                disabled={
                  personalDetails.isEarlierEPF1952Scheme === 0 &&
                  personalDetails.isEarlierEPF1995Scheme === 0
                }
                onBlur={handleOnBlurInput}
                isInvalid={errors.previousPFNumber}
              />
              {errors.previousPFNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.previousPFNumber.type === "required" &&
                    "PREVIOUS PF Account Number is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="dateOfExitFromPrevEmp">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              c) DATE OF EXIT From PREVIOUS Employment*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="DATE OF EXIT From PREVIOUS Employment"
                type="date"
                name="previousEmpExitDate"
                value={getFormattedDate(
                  personalDetails.previousEmpExitDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
                onChange={handleOnChangePersonalDetails}
                disabled={
                  personalDetails.isEarlierEPF1952Scheme === 0 &&
                  personalDetails.isEarlierEPF1995Scheme === 0
                }
                onBlur={handleOnBlurInput}
                isInvalid={errors.previousEmpExitDate}
              />
              {errors.lastWorkingDate && (
                <Form.Control.Feedback type="invalid">
                  {errors.previousEmpExitDate.type === "required" &&
                    "Previous Employment Date of Exit is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="schemeCertificateNo">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              d) Scheme Certificate No.(if Issued)
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                placeholder="Scheme Certificate No.(if Issued)"
                type="text"
                name="schemeCertificateNumber"
                value={personalDetails.schemeCertificateNumber}
                onChange={handleOnChangePersonalDetails}
                disabled={
                  personalDetails.isEarlierEPF1952Scheme === 0 &&
                  personalDetails.isEarlierEPF1995Scheme === 0
                }
              />
            </Col>
            <Col sm={4} />
          </Form.Group>

          <Form.Group as={Row} controlId="international Worker">
            <Col className="mt-2" sm={1}>
              10
            </Col>
            <Form.Label column sm={4}>
              a) International Worker*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="International Worker"
                as="select"
                name="isInternationalWorker"
                value={getInternationalWorker()}
                onChange={handleOnChangePersonalDetails}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </Form.Control>
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="stateCountry">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              b) if Yes, State Country of origin (India/Name of other Country)*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Country Name"
                type="text"
                name="countryOrigin"
                value={personalDetails.countryOrigin}
                disabled={!personalDetails.isInternationalWorker}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={
                  +personalDetails.isInternationalWorker && errors.countryOrigin
                }
              />
              {errors.countryOrigin && (
                <Form.Control.Feedback type="invalid">
                  {errors.countryOrigin.type === "required" &&
                    "Country of Origin is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="passportNo">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              c) Passport No*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Passport No"
                type="text"
                name="passportNo"
                value={personalDetails.passportNo}
                onChange={handleOnChangePersonalDetails}
                disabled={!personalDetails.isInternationalWorker}
                onBlur={handleOnBlurInput}
                isInvalid={
                  +personalDetails.isInternationalWorker && errors.passportNo
                }
              />
              {errors.passportNo && (
                <Form.Control.Feedback type="invalid">
                  {errors.passportNo.type === "required" &&
                    "Passport Number is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="passportValidityDate">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              d) Validity of Passport*
            </Form.Label>
            <Col sm={3}>
              Start Date
              <Form.Control
                size="sm"
                required
                placeholder="Passport Start Date"
                type="date"
                name="passportValidityFrom"
                value={getFormattedDate(
                  personalDetails.passportValidityFrom,
                  undefined,
                  "YYYY-MM-DD"
                )}
                onChange={handleOnChangePersonalDetails}
                disabled={!personalDetails.isInternationalWorker}
                onBlur={handleOnBlurInput}
                isInvalid={
                  +personalDetails.isInternationalWorker &&
                  errors.passportValidityFrom
                }
              />
              {errors.passportValidityFrom && (
                <Form.Control.Feedback type="invalid">
                  {errors.passportValidityFrom.type === "required" &&
                    "Passport Start Date is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              End Date
              <Form.Control
                size="sm"
                required
                placeholder="End Date"
                type="date"
                name="passportValidityTo"
                value={getFormattedDate(
                  personalDetails.passportValidityTo,
                  undefined,
                  "YYYY-MM-DD"
                )}
                onChange={handleOnChangePersonalDetails}
                disabled={!personalDetails.isInternationalWorker}
                onBlur={handleOnBlurInput}
                isInvalid={
                  +personalDetails.isInternationalWorker &&
                  errors.passportValidityTo
                }
              />
              {errors.passportValidityTo && (
                <Form.Control.Feedback type="invalid">
                  {errors.passportValidityTo.type === "required" &&
                    "Passport End Date is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={1} />
          </Form.Group>
          <div className="row mb-3">
            <Col sm={1}>11</Col>
            <Col sm={6}>
              KYC Details; (attach self-attested copies of following KYCs)
            </Col>
          </div>
          <Form.Group as={Row} controlId="aADHARNumber">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              a) AADHAR Number*
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="AADHAR Number"
                type="text"
                name="aADHARNumber"
                value={personalDetails.adhaarNumber}
                disabled
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
          <Form.Group as={Row} controlId="pAN">
            <Col sm={1}></Col>
            <Form.Label column sm={4}>
              b) Permanent Account Number (PAN), if available
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                size="sm"
                required
                placeholder="Permanent Account Number (PAN)"
                type="text"
                name="pan"
                value={personalDetails.panCardNo}
                disabled
              />
            </Col>
            <Col sm={4} />
          </Form.Group>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>UNDER TAKING</Card.Header>
        <Card.Body>
          <ol>
            <li>
              Certified that the particular are true to the best of my
              knowledge.
            </li>
            <li>
              I authorize EPFO to use my Aadhar for
              verification/authentication/eKYC purpose for service delivery.
            </li>
            <li>
              Kindly transfer the funds and service details, if applicable, from
              the previous PF account as declared above to the present PF
              Account. (The transfer would be possible only if the identified
              KYC detail approved by previous employer has been verified by
              present employer using his Digital Signature Cerificate)
            </li>
            <li>
              In case of changes in above details, the same will be intimated to
              employer at the earliest.
            </li>
          </ol>
          <Row className="mt-2">
            <Col sm={4}>
              <Form.Label>Date*</Form.Label>
              <Form.Control
                size="sm"
                required
                disabled
                placeholder="Date"
                type="date"
                name="pan"
                value={getFormattedDate(
                  personalDetails.declarationDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
              />
              <Form.Label>Place*</Form.Label>
              <Form.Control
                size="sm"
                required
                placeholder="Place"
                type="text"
                name="declarationPlace"
                value={getDeclarationPlace(personalDetails.declarationPlace)}
                disabled
              />
            </Col>
            <Col sm={4}></Col>
            <Col sm={4}>
              <Form.Control
                disabled
                size="sm"
                required
                type="text"
                name="signature"
                value={getFullName(personalDetails)}
              />
              <Form.Label>SIGNATURE OF MEMBER*</Form.Label>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>DECLARATION BY PRESENT EMPLOYER</Card.Header>
        <Card.Body>
          <ol type="A">
            <li>
              THE MEMBER Mr./Ms./Mrs. ………………………….. HAS JOINED ON ………………….. AND
              HAS BEEN ALLOTTED PF MEMBER ID
            </li>
            <li>
              IN CASE THE PERSON WAS EARLIER NOT A MEMBER OF EPF SCHEME, 1952
              AND EPS, 1995:
              <ul>
                <li>
                  (POST ALLOTMENT OF UAN) THE UAN ALLOTED FOR THE MEMBER IS
                  ____________
                </li>
                <li>
                  PLEASE TICK THE APPROPRIATE OPTION:
                  <ul>
                    THE KEY DETAILS OF THE ABOVE MEMBER IN THE UAN DATABASE
                    <li>HAVE NOT BEEN UPLOADED</li>
                    <li>HAVE BEEN UPLOADED BUT NOT APPROVED</li>
                    <li>HAVE BEEN UPLOADED AND APPROVED WITH DSC</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              IN CASE THE PERSON WAS EARLIER A MEMBER OF EPF SCHEME, 1952 AND
              EPS, 1995:
              <ul>
                <li>
                  The above PF Account number/UAN of the member's as mentioned
                  in (A) above has been tagged with his/her UAN/Previous member
                  ID as declared by member
                </li>
              </ul>
              PLEASE TICK THE APPROPRIATE OPTION:
              <ul>
                <li>
                  THE KYC DETAILS OF THE ABOVE MEMBER IN THE UAN DATABASE HAVE
                  BEEN APPROVED WITH DIGITAL SIGNATURE CERTIFICATE AND TRANSFER
                  REQUEST HAS BEEN GENERATED ON PRO
                </li>
                <li>
                  AS THE DSC OF ESTABLISHMENT ARE NOT REGISTERED WITH EPFO, THE
                  MEMBER HAS BEEN INFORMED TO FILE PHYSICAL CLAIM (FORM- 13) FOR
                  TRANSFER OF FUNDS FROM HIS PREVIOUS ESTABLISHMENT.
                </li>
              </ul>
            </li>
          </ol>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default EPFForm11;
